import React ,{ useEffect, useRef } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import { IFilterActeursJuridiquesSearch, getDefaultFilterActeursJuridiques } from "../../../models/interfaces/IFilterActeursJuridiquesSearch";
import CpntFilterButtons from "../../../components/CpntFilterButtons";

interface IProps {
  filter?: IFilterActeursJuridiquesSearch;
  changeFilter: (data: IFilterActeursJuridiquesSearch) => void;
}


//Arrive pas a faire passer unb param au parent...
const CompteSocieteActeursJuridiquesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterActeursJuridiquesSearch | undefined>(filter);

  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }

    prevFilterRef.current = filter;
  }, [filter]);
  
  const formMethods = useForm<IFilterActeursJuridiquesSearch>({
    defaultValues: getDefaultFilterActeursJuridiques(),
  });

  const { handleSubmit, reset, getValues } = formMethods;


  const handleResetForm = () => {
    localStorage.removeItem("IFilterActeursJuridiquesSearch");
    changeFilter(getDefaultFilterActeursJuridiques());
    reset(getDefaultFilterActeursJuridiques()); // Réinitialise explicitement le formulaire
  };


  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };


  const onSubmit = (data: IFilterActeursJuridiquesSearch) => {
    changeFilter(data);
    localStorage.setItem("IFilterActeursJuridiquesSearch",JSON.stringify(data)); //needed ??
  };

  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      //e.preventDefault();
      handleSubmit(onSubmit)();
      //SubmitButton.current.click();
    }
  };
  

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6, 12]}>
            <TextInput
              label="Recherche"
              formName="SearchLibelle"
              validationStyle={validationMode.none}
              placeholder="Acteur Juridique recherché"
            />
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default CompteSocieteActeursJuridiquesFilter;
